import classNames from "classnames";
import React from "react";

import useLanguage from "@hooks/useLanguage";

export interface IProps {
  name: string;
  zip: string;
  city: string;
  address1: string;
  address2: string;
  phone: string;
  country?: string;
  province?: string;
  className?: string;
}

export default function Address({ name, zip, city, address1, address2, phone, country, province, className }: IProps) {
  const { lang } = useLanguage();

  return (
    <div className={classNames("flex flex-col leading-4.5", className)}>
      <span>{name}</span>
      {lang === "ko" ? (
        <>
          <span>{province}</span>
          <span>{`${address1} (${zip})`}</span>
          <span>{address2}</span>
        </>
      ) : (
        <>
          <span>{`${address1}${address2 ? `, ${address2}` : ""}`}</span>
          <span>{`${city}, ${province} ${zip} (${country})`}</span>
        </>
      )}
      <span>{phone}</span>
    </div>
  );
}
